import { useCallback, useEffect, useMemo, useState } from "react";
import { Error as ErrorMsg } from "../../../../commons/Messages/Messages";
import { errorText, listAccounts } from "./api";

/** The tenant's full chart, loaded once per page and shared by every tab. */
const useAccounts = () => {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const res = await listAccounts();
      setAccounts(res.data.accounts || []);
    } catch (err) {
      ErrorMsg(errorText(err, "Could not load accounts"));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  const byNumber = useMemo(() => new Map(accounts.map(a => [a.number, a])), [accounts]);
  const byRole = useMemo(
    () => new Map(accounts.filter(a => a.role).map(a => [a.role, a])),
    [accounts]
  );

  // Options for an account Select; search matches number prefix or name substring.
  const options = useMemo(
    () =>
      accounts
        .filter(a => a.active)
        .map(a => ({
          value: a.number,
          label: `${a.number} ${a.name}`,
          search: `${a.number} ${a.name}`.toLowerCase()
        })),
    [accounts]
  );

  return { accounts, byNumber, byRole, options, loading, reload };
};

export const filterAccountOption = (input, option) =>
  (option?.search || "").includes(String(input || "").toLowerCase());

export default useAccounts;
